import { log } from '~/utils/log';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type ArticleCardTargetProperties = {
  article_id: string;
  module_position?: number;
  module_type: string;
  position: number;
  search_term?: string;
};

type EventData = {
  articleId: string | undefined;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType: string;
  position: number;
  searchTerm?: string;
};

class ArticleCardInteractionEvent extends InteractionEvent<
  EventData,
  ArticleCardTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'article_card';
  }

  // Bots are dropped before the id is validated, not by the base class after it. A crawler
  // clicking an id-less card is not a gap worth an error line per click — only real traffic
  // losing an event is.
  async send() {
    if (this.data.isBot) return;

    if (!this.data.articleId) {
      log.error('ArticleCardInteractionEvent fired without an article_id', {
        module_type: this.data.moduleType,
        position: this.data.position
      });

      return;
    }

    return super.send();
  }

  protected getTargetProperties(): ArticleCardTargetProperties {
    return {
      article_id: String(this.data.articleId),
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      position: this.data.position,
      search_term: this.data.searchTerm
    };
  }
}

export default ArticleCardInteractionEvent;
